import { OutfitData } from "../../../types/Profile";
import OutfitCard from "../OutfitCard";

interface PotentialTabProps {
  outfits: OutfitData[];
  favouritedOutfits: string[];
  onToggleFavourite: (id: string) => void;
}

export default function PotentialTab({
  outfits,
  favouritedOutfits,
  onToggleFavourite,
}: PotentialTabProps) {
  const potentialOutfits = outfits.filter(outfit => 
    new Date(outfit.createdAt) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-extralight tracking-[0.3em] uppercase text-gray-900 dark:text-white">
          POTENTIAL ENSEMBLES
        </h2>
        <p className="mt-2 text-sm font-light tracking-wider text-gray-600 dark:text-gray-400">
          Fresh inspirations awaiting discovery
        </p>
      </div>
      
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {potentialOutfits.map((outfit) => (
          <OutfitCard 
            key={outfit.id} 
            outfit={outfit} 
            onToggleFavourite={onToggleFavourite} 
            isFavourited={favouritedOutfits.includes(outfit.id)} 
          />
        ))}
      </div>
    </div>
  );
}